import { FC } from 'react';
import ProInputNumber, { NewInputNumberProps } from './inputNumber';

export type IInputNumberComponent = FC<
  NewInputNumberProps & React.RefAttributes<HTMLElement>
>;

const TransInputNumber = ProInputNumber as IInputNumberComponent;

export default TransInputNumber;
